import { render } from "./WorkExperienceComponent.vue?vue&type=template&id=4e2bc8ad"
import script from "./WorkExperienceComponent.vue?vue&type=script&lang=js"
export * from "./WorkExperienceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__